import * as $runtime from "../runtime.js";
import * as Control$dApplicative from "../Control.Applicative/index.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Control$dMonad$dReader$dTrans from "../Control.Monad.Reader.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCodec from "../Data.Codec/index.js";
import * as Data$dCodec$dJSON from "../Data.Codec.JSON/index.js";
import * as Data$dCodec$dJSON$dCommon from "../Data.Codec.JSON.Common/index.js";
import * as Data$dCodec$dJSON$dRecord from "../Data.Codec.JSON.Record/index.js";
import * as Data$dCodec$dJSON$dSum from "../Data.Codec.JSON.Sum/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as JSON$dPath from "../JSON.Path/index.js";
import * as TcgCalculator$dTypes from "../TcgCalculator.Types/index.js";
const countIsSymbol = {reflectSymbol: () => "count"};
const cardsIsSymbol = {reflectSymbol: () => "cards"};
const object1 = /* #__PURE__ */ Data$dCodec$dJSON$dRecord.object()(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()({
  reflectSymbol: () => "others"
}))()()({reflectSymbol: () => "hand"}))()()(cardsIsSymbol));
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(xs => {
    if (xs.tag === "Nil") { return Data$dMaybe.Nothing; }
    if (xs.tag === "Cons") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(xs._1, xs._2)); }
    $runtime.fail();
  });
  return x => $0((() => {
    const go = (m$p, z$p) => {
      if (m$p.tag === "Leaf") { return z$p; }
      if (m$p.tag === "Node") { return go(m$p._5, Data$dList$dTypes.$List("Cons", m$p._3, go(m$p._6, z$p))); }
      $runtime.fail();
    };
    return go(x, Data$dList$dTypes.Nil);
  })());
})();
const bindExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.bindExceptT(Effect.monadEffect);
const bind = /* #__PURE__ */ (() => Control$dMonad$dReader$dTrans.bindReaderT(bindExceptT).bind)();
const ask = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Effect.monadEffect).pure)();
const monadEffectExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.monadEffectExceptT(Effect$dClass.monadEffectEffect);
const generateId = /* #__PURE__ */ (() => Control$dMonad$dReader$dTrans.monadEffectReader(monadEffectExceptT).liftEffect(Data$dUUID.getUUIDImpl))();
const traverse2 = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe))();
const applicativeExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.applicativeExceptT(Effect.monadEffect);
const applicativeReaderT = /* #__PURE__ */ (() => {
  const $0 = applicativeExceptT.Apply0();
  const $1 = $0.Functor0();
  const functorReaderT1 = {
    map: x => {
      const $2 = $1.map(x);
      return v => x$1 => $2(v(x$1));
    }
  };
  const applyReaderT1 = {apply: v => v1 => r => $0.apply(v(r))(v1(r)), Functor0: () => functorReaderT1};
  return {
    pure: x => {
      const $2 = applicativeExceptT.pure(x);
      return v => $2;
    },
    Apply0: () => applyReaderT1
  };
})();
const fromFoldable = /* #__PURE__ */ Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dUUID.ordUUID)(a)()(m))(Data$dMap$dInternal.Leaf);
const apply = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.applyExceptT(Effect.monadEffect);
  return v => v1 => r => $0.apply(v(r))(v1(r));
})();
const generateId1 = /* #__PURE__ */ (() => monadEffectExceptT.liftEffect(Data$dUUID.getUUIDImpl))();
const traverse3 = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(applicativeExceptT))();
const disabledIsSymbol = {reflectSymbol: () => "disabled"};
const conditionsIsSymbol = {reflectSymbol: () => "conditions"};
const conditionIsSymbol = {reflectSymbol: () => "condition"};
const object2 = /* #__PURE__ */ Data$dCodec$dJSON$dRecord.object()(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()({
  reflectSymbol: () => "deck"
}))()()(conditionIsSymbol));
const idIsSymbol = {reflectSymbol: () => "id"};
const rowListCodecConsCodec3 = /* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(/* #__PURE__ */ Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()(idIsSymbol))()()(disabledIsSymbol))()();
const id = /* #__PURE__ */ Data$dCodec.$Codec(
  j => {
    const v = Data$dCodec$dJSON.string._1(j);
    if (v.tag === "Left") { return Data$dEither.$Either("Left", {path: v._1.path, message: "Could not decode Id", causes: [v._1]}); }
    if (v.tag === "Right") {
      if (Data$dUUID.validateV4UUID(v._1)) { return Data$dEither.$Either("Right", v._1); }
      return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode Id, unexpected value found", causes: []});
    }
    $runtime.fail();
  },
  b => Data$dTuple.$Tuple(Data$dCodec$dJSON.string._2(b)._1, b)
);
const hashCard = /* #__PURE__ */ (() => Data$dCodec$dJSON.object(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()({
  reflectSymbol: () => "name"
}))()()(countIsSymbol).rowListCodec({name: Data$dCodec$dJSON.string, count: Data$dCodec$dJSON.int})))();
const hashDeck = /* #__PURE__ */ object1({cards: /* #__PURE__ */ Data$dCodec$dJSON.array(hashCard), others: Data$dCodec$dJSON.int, hand: Data$dCodec$dJSON.int});
const hashAppState$p = /* #__PURE__ */ (() => {
  const encodeConditionGroup = Data$dTraversable.traversableArray.traverse(Control$dApplicative.applicativeFn)(v => ids => (
    {
      mode: v.condition.mode,
      count: v.condition.count,
      cards: toUnfoldable(Data$dSet.mapMaybe(Data$dOrd.ordInt)(x => Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v$1 => v$1 === x, ids))(v.condition.cards)),
      disabled: v.disabled
    }
  ));
  const encodeConditionSet = Data$dTraversable.traversableArray.traverse(Control$dApplicative.applicativeFn)(v => {
    const $0 = v.disabled;
    const $1 = encodeConditionGroup(v.conditions);
    return x => ({conditions: $1(x), disabled: $0});
  });
  const decodeConditionGroup = Data$dTraversable.traversableArray.traverse(applicativeReaderT)(v => {
    const $0 = v.cards;
    const $1 = v.count;
    const $2 = v.disabled;
    const $3 = v.mode;
    return bind(ask)(cardIds => bind(generateId)(conditionId => bind((() => {
      const $4 = traverse2(v1 => {
        if (v1 >= 0 && v1 < cardIds.length) { return Data$dMaybe.$Maybe("Just", cardIds[v1]); }
        return Data$dMaybe.Nothing;
      })($0);
      const $5 = (() => {
        if ($4.tag === "Nothing") { return Data$dEither.$Either("Left", {path: JSON$dPath.Tip, message: "Could not decode conditions", causes: []}); }
        if ($4.tag === "Just") { return Data$dEither.$Either("Right", $4._1); }
        $runtime.fail();
      })();
      return v$1 => () => $5;
    })())(cards$p => applicativeReaderT.pure({id: conditionId, condition: {mode: $3, count: $1, cards: fromFoldable(cards$p)}, disabled: $2}))));
  });
  const decodeConditionSet = Data$dTraversable.traversableArray.traverse(applicativeReaderT)(v => {
    const $0 = v.disabled;
    return apply(x => {
      const $1 = generateId(x);
      return () => {
        const a$p = $1();
        if (a$p.tag === "Left") { return Data$dEither.$Either("Left", a$p._1); }
        if (a$p.tag === "Right") {
          return Data$dEither.$Either(
            "Right",
            (() => {
              const $2 = a$p._1;
              return v2 => ({id: $2, conditions: v2, disabled: $0});
            })()
          );
        }
        $runtime.fail();
      };
    })(decodeConditionGroup(v.conditions));
  });
  return Data$dCodec.$Codec(
    v => {
      const $0 = v.deck.hand;
      const $1 = v.deck.others;
      const $2 = v.condition;
      return bindExceptT.bind(traverse3(v$1 => {
        const $3 = v$1.count;
        const $4 = v$1.name;
        return () => {
          const a$p = generateId1();
          if (a$p.tag === "Left") { return Data$dEither.$Either("Left", a$p._1); }
          if (a$p.tag === "Right") { return Data$dEither.$Either("Right", {id: a$p._1, name: $4, count: $3}); }
          $runtime.fail();
        };
      })(v.deck.cards))(cards$p => bindExceptT.bind(decodeConditionSet($2)(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p)))(condition => applicativeExceptT.pure({
        deck: {cards: cards$p, hand: $0, others: $1},
        condition
      })));
    },
    b => Data$dTuple.$Tuple(
      {
        deck: {cards: Data$dFunctor.arrayMap(v => ({name: v.name, count: v.count}))(b.deck.cards), hand: b.deck.hand, others: b.deck.others},
        condition: encodeConditionSet(b.condition)(Data$dFunctor.arrayMap(v1 => v1.id)(b.deck.cards))
      },
      b
    )
  );
})();
const conditionMode = /* #__PURE__ */ (() => Data$dCodec$dJSON$dSum.enumSum(TcgCalculator$dTypes.showConditionMode.show)(TcgCalculator$dTypes.readConditionMode))();
const hashCondition = /* #__PURE__ */ (() => Data$dCodec$dJSON.object(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()({
  reflectSymbol: () => "mode"
}))()()(disabledIsSymbol))()()(countIsSymbol))()()(cardsIsSymbol).rowListCodec({
  mode: conditionMode,
  count: Data$dCodec$dJSON.int,
  cards: Data$dCodec$dJSON.array(Data$dCodec$dJSON.int),
  disabled: Data$dCodec$dJSON.boolean
})))();
const hashConditionGroup = /* #__PURE__ */ Data$dCodec$dJSON$dCommon.nonEmptyArray(hashCondition);
const hashConditionSet = /* #__PURE__ */ (() => Data$dCodec$dJSON.array(Data$dCodec$dJSON.object(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()(disabledIsSymbol))()()(conditionsIsSymbol).rowListCodec({
  conditions: hashConditionGroup,
  disabled: Data$dCodec$dJSON.boolean
}))))();
const hashState = /* #__PURE__ */ object2({deck: hashDeck, condition: hashConditionSet});
const hashAppState = /* #__PURE__ */ Data$dCodec.$Codec(
  a => bindExceptT.bind((() => {
    const $0 = hashState._1(a);
    return () => $0;
  })())(hashAppState$p._1),
  x => {
    const $0 = hashAppState$p._2(x);
    return Data$dTuple.$Tuple(hashState._2($0._1)._1, $0._2);
  }
);
const appCondition = /* #__PURE__ */ (() => Data$dCodec$dJSON.object(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()({
  reflectSymbol: () => "mode"
}))()()(countIsSymbol))()()(cardsIsSymbol).rowListCodec({mode: conditionMode, count: Data$dCodec$dJSON.int, cards: Data$dCodec$dJSON$dCommon.set(Data$dUUID.ordUUID)(id)})))();
const appConditionGroup = /* #__PURE__ */ (() => Data$dCodec$dJSON$dCommon.nonEmptyArray(Data$dCodec$dJSON.object(rowListCodecConsCodec3(conditionIsSymbol).rowListCodec({
  id,
  condition: appCondition,
  disabled: Data$dCodec$dJSON.boolean
}))))();
const appConditionSet = /* #__PURE__ */ (() => Data$dCodec$dJSON.array(Data$dCodec$dJSON.object(rowListCodecConsCodec3(conditionsIsSymbol).rowListCodec({
  id,
  conditions: appConditionGroup,
  disabled: Data$dCodec$dJSON.boolean
}))))();
const appCard = /* #__PURE__ */ (() => Data$dCodec$dJSON.object(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecConsCodec(Data$dCodec$dJSON$dRecord.rowListCodecNilRowRow)()()({
  reflectSymbol: () => "name"
}))()()(idIsSymbol))()()(countIsSymbol).rowListCodec({id, name: Data$dCodec$dJSON.string, count: Data$dCodec$dJSON.int})))();
const appDeck = /* #__PURE__ */ object1({cards: /* #__PURE__ */ Data$dCodec$dJSON.array(appCard), others: Data$dCodec$dJSON.int, hand: Data$dCodec$dJSON.int});
const appState = /* #__PURE__ */ object2({deck: appDeck, condition: appConditionSet});
export {
  appCard,
  appCondition,
  appConditionGroup,
  appConditionSet,
  appDeck,
  appState,
  applicativeExceptT,
  applicativeReaderT,
  apply,
  ask,
  bind,
  bindExceptT,
  cardsIsSymbol,
  conditionIsSymbol,
  conditionMode,
  conditionsIsSymbol,
  countIsSymbol,
  disabledIsSymbol,
  fromFoldable,
  generateId,
  generateId1,
  hashAppState,
  hashAppState$p,
  hashCard,
  hashCondition,
  hashConditionGroup,
  hashConditionSet,
  hashDeck,
  hashState,
  id,
  idIsSymbol,
  monadEffectExceptT,
  object1,
  object2,
  rowListCodecConsCodec3,
  toUnfoldable,
  traverse2,
  traverse3
};
